
import Visual1 from "../../../img/screenshots/hotels/hotel-feature-01.png";
import Visual2 from "../../../img/screenshots/hotels/hotel-feature-02.png";
import Visual4 from "../../../img/screenshots/hotels/hotel-feature-04.png";



export const HotelFeaturesContent = [
    { 
      title:"Increase Partnership revenue",     
      subtitle:"Your digital Stippl profile",      
      text:"Stippl helps hotels make more money by connecting them with local businesses and tour operators. Guests book tours, activities, restaurant reservations and spa appointments through the app and the hotel earns commissions and referral fees for those bookings, adding up to significant additional revenue.",
      image:Visual1
    },
    { 
      title:"Enhanced guest experience",     
      subtitle:"Your digital folder",      
      text:"Stippl enhances the guest experience by replacing traditional check-in folders with a digital concierge service. Instead of sifting through a stack of brochures and flyers, guests can simply open the app and browse a wide range of activities, services and recommendations tailored to their interests and preferences.",
      image:Visual2
    },
    { 
      title:"Personalised mobile app for guests",     
      subtitle:"Recommendations in the pocket",      
      text:"Our mobile app for hotels is an efficient and effective solution for hotels looking to enhance their guest experience and increase revenue. The app is always with the guest, which means that hotels can provide personalised recommendations and services at all times.",
      image:Visual4
    }
  ]